interface IRadioIconProps {
  readonly selected?: boolean;
  readonly size?: number;
}

export function RadioIcon({ selected, size = 16 }: IRadioIconProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      className="flex-none self-center inline-block"
    >
      {/* Unselected: outlined circle */}
      {!selected && (
        <path
          fill="currentColor"
          d="M12,24A12,12,0,1,1,24,12,12.013,12.013,0,0,1,12,24ZM12,2A10,10,0,1,0,22,12,10.011,10.011,0,0,0,12,2Z"
        />
      )}

      {/* Selected: solid ring (donut) */}
      {selected && (
        <path
          fill="currentColor"
          fillRule="evenodd"
          d="
            M12 2
            A10 10 0 1 1 12 22
            A10 10 0 1 1 12 2
            M12 8
            A4 4 0 1 0 12 16
            A4 4 0 1 0 12 8
          "
        />
      )}
    </svg>
  );
}
